<div class="card">
  <h2>{{ 'eventsList.title' | translate }}</h2>
  <p class="events-subtitle">{{ 'eventsList.subtitle' | translate }}</p>
  <bo-event-list-filter [events]="futureEvents()" />
</div>
